declare global {
  interface Window { __WARROOM_API__?: string }
}

export function apiBase(): string {
  if (typeof window !== "undefined" && window.__WARROOM_API__) {
    return window.__WARROOM_API__.replace(/\/$/, "");
  }
  if (typeof window !== "undefined" && window.location.hostname === "localhost") {
    return "http://127.0.0.1:7682";
  }
  return "https://warroom-api.ratcap.io";
}

export function wsBase(): string {
  return apiBase().replace(/^http/, "ws");
}

export type LaneRow = {
  name: string;
  role: string;
  emoji: string;
  signoff: string;
  workdir: string;
  status: "idle" | "embodied" | "working" | "stuck" | "dead" | string;
  last_active: string | null;
  last_embodied: string | null;
  inbox_unread: number;
  dirty_files: number;
};

export async function fetchLanes(signal?: AbortSignal): Promise<LaneRow[]> {
  const r = await fetch(`${apiBase()}/lanes`, { credentials: "include", signal });
  if (!r.ok) throw new Error(`lanes ${r.status}`);
  return (await r.json()) as LaneRow[];
}

export type FeedEvent = {
  ts?: string;
  lane?: string;
  kind?: string;
  body?: string;
  [k: string]: unknown;
};

export function openFeed(onEvent: (e: FeedEvent) => void): () => void {
  const es = new EventSource(`${apiBase()}/feed`, { withCredentials: true });
  es.onmessage = (m) => {
    try { onEvent(JSON.parse(m.data) as FeedEvent); }
    catch { /* skip non-json frames */ }
  };
  es.onerror = () => { /* let browser auto-reconnect */ };
  return () => es.close();
}

export function openTerminalWS(lane: string): WebSocket {
  return new WebSocket(`${wsBase()}/lanes/${encodeURIComponent(lane)}/terminal`);
}

export async function laneAction(lane: string, action: "embody" | "disembody"): Promise<void> {
  await fetch(`${apiBase()}/lanes/${encodeURIComponent(lane)}/${action}`, {
    method: "POST", credentials: "include",
  });
}

export async function laneSend(lane: string, text: string): Promise<void> {
  await fetch(`${apiBase()}/lanes/${encodeURIComponent(lane)}/send`, {
    method: "POST", credentials: "include",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ text }),
  });
}
